import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import useStyles from 'pages/book-activity/components/booking-summary/styles';

import { Typography } from '@material-ui/core';

import { LOCALES_OBJ } from 'constants/base';

import { currencyFormatter } from 'utils/prices/formatter';
import { getTotalPrice } from 'utils/book-rental-items/rentalTotalPrice';
import { getFormByCurrentLanguage } from 'utils/form-localization/formLocalization';
import { AddOnsComponent } from 'pages/book-activity/components/booking-summary/BookingSummary';

const RentalBookingSummary = ({
  rentalItems,
  bookRentalItems,
  generalSectionTitle
}) => {  
  
  
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  const getRentalItemsSummaryDate = () => {
    if (
      bookRentalItems.multiDates &&
      bookRentalItems.multiDates.startDate &&
      bookRentalItems.multiDates.endDate
    ) {
      const startDate = moment(bookRentalItems.multiDates.startDate)
        .locale(LOCALES_OBJ[selectedLanguage])
        .format('MMM DD, YYYY');
      const endDate = moment(bookRentalItems.multiDates.endDate)
        .locale(LOCALES_OBJ[selectedLanguage])
        .format('MMM DD, YYYY');

      return `${startDate} – ${endDate} `;
    }

    const startingDate = bookRentalItems.startingDate;


    let dateStr = ``;

    if (startingDate) {
      dateStr = `${moment(bookRentalItems.startingDate)
        .locale(LOCALES_OBJ[selectedLanguage])
        .format('MMM DD, YYYY')}`;
    }

    return dateStr;
  };

  const isRentalItemsSummary = () => {
    let isShow = false;

    bookRentalItems.availableUnits.map(item => {
      if (!item.availableUnits || !parseInt(item.availableUnits)) return;
      isShow = true;
    });

    return isShow;
  };

  const isAddOnsSummary = () => {
    let isShow = false;

    bookRentalItems.addOns.map(item => {
      if (!item.value || !parseInt(item.value)) return;
      isShow = true;
    });

    return isShow;
  };

  if (!isRentalItemsSummary() && !isAddOnsSummary()) {
    return null;
  }

  return (
    <div className={classes.summeryWrapper}>
      <Typography variant="h2" className={classes.inputIndent}>
        {t('Booking summary')}
      </Typography>
      {isRentalItemsSummary() && (
        <div className={classes.inputIndent}>
          <Typography variant="h3" className={classes.summaryTitle}>
            {t(generalSectionTitle)}
          </Typography>
          <Typography variant="body1" className={classes.summaryActivityName}>
            {
              getFormByCurrentLanguage(
                selectedLanguage,
                rentalItems.generalForm,
                rentalItems['generalForm-Norwegian']
              ).title
            }
          </Typography>
          <Typography variant="body1" className={classes.summaryActivityInfo}>
            {getRentalItemsSummaryDate()}
          </Typography>
          <div className={classes.summaryPricesList}>
            {bookRentalItems.availableUnits.map(item => {
              if (!item.availableUnits || !parseInt(item.availableUnits))
                return;
              const price = currencyFormatter(item.currencyValue);

              let summaryPrice =
                item.currencyValue * parseInt(item.availableUnits);
           

              const days =
                bookRentalItems.multiDates && bookRentalItems.multiDates.endDate
                  ? bookRentalItems.multiDates.endDate.diff(
                      bookRentalItems.multiDates.startDate,
                      'days'
                    ) + 1
                  : 0;
              const pluralDays = days > 1 ? t('days') : t('day');
              
              summaryPrice = currencyFormatter(summaryPrice);
              return (
                <div key={item.id} className={classes.summaryPricesItem}>
                  {
                    <>
                      {rentalItems.pricesType === 'pricesFixedForm' ? (
                        <Typography variant="body1">
                          <span className={classes.summaryCurrency}>
                            {item.currency}
                          </span>{' '}
                          {price}
                          {!!item && (
                            <>
                              {' '}
                              × {item.availableUnits} {t('Units')}
                            </>
                          )}
                          {!!item.days && item.days > 1 && (
                            <>
                              {' '}
                              - {item.days}{' '}
                              {item.days > 1 ? t('Days') : t('Day')}
                            </>
                          )}
                        </Typography>
                      ) : (
                        <Typography variant="body1">
                          <span className={classes.summaryCurrency}>
                            {item.currency}
                          </span>{' '}
                          {price} × {item.availableUnits} {t('Units')}
                          {!!days && (
                            <>
                              {' '}
                              - {days} {pluralDays}
                            </>
                          )}
                        </Typography>
                      )}
                    </>
                  }
                  <Typography variant="body1">
                    {item.currency}{' '}
                    <span className={classes.summaryPrice}>{summaryPrice}</span>
                  </Typography>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {isAddOnsSummary() && (
        <AddOnsComponent
          addOns={bookRentalItems.addOns}
          currency={bookRentalItems.currency}
        />
      )}

      <div className={classes.summaryTotal}>
        <Typography variant="h2" className={classes.fontWeight}>
          {t('Total')}
        </Typography>
        <Typography variant="h3" className={classes.summaryTotalPriceBlock}>
          {bookRentalItems.currency}{' '}
          <span className={classes.summaryTotalPrice}>
            {currencyFormatter(
              getTotalPrice(
                rentalItems,
                bookRentalItems.startingDate,
                bookRentalItems.endTime,
                bookRentalItems.startTime,
                bookRentalItems.multiDates,
                bookRentalItems.availableUnits,
                bookRentalItems.addOns,
                bookRentalItems.currency
              )
            )}
          </span>
        </Typography>
      </div>
    </div>
  );
};

export default RentalBookingSummary;
